import EcoEmail from 'eco-design/elements/eco-email';
import dayjs from 'dayjs';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useGlobal } from '@/utils/useGlobal';

const CONTACT_LIST_ID_MAP = {
    us: '1487185288',
};
function TheComp() {
    const { getSystemTime } = useGlobal();
    const { locale = 'us' } = getLocal();
    const { t } = useLang('costsaving-new');

    const systemTime = getSystemTime();
    const date = dayjs(systemTime).format('YYYY-MM-DD') as any;
    const FIELDS_MAP = {
        us: [
            {
                type: 'single',
                id: '4423',
                value: 1,
                overwrite: true,
            },
            {
                type: 'single',
                id: '31',
                value: 1,
                overwrite: false,
            },
            {
                type: 'multiple',
                id: '9435',
                value: [10],
                overwrite: false,
            },
            {
                type: 'text',
                id: '9625',
                value: date,
                overwrite: false,
            },
        ],
    };

    return (
        <section
            className={`${css.section} cost-saving-A GtmModuleData-section`}
            id="cost-saving-A"
            data-section-id={'cost-saving-A'}
            data-section-title={t('A_title')}
        >
            <div className="A-img">
                <picture className="picture">
                    <source media={`(min-width: 1025px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1768186745215/home-carousel-banner.webp'} type="image/webp" />
                    <source media={`(min-width: 1025px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1768186300302/home-carousel-banner.jpg'} type="image/jpg" />
                    <source media={`(max-width: 1024px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1768186744893/home-carousel-banner%20(1).webp'} type="image/webp" />
                    <source media={`(max-width: 1024px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1768186300485/home-carousel-banner%20(2).jpg'} />
                    <source media={`(max-width: 768px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1768186745024/home-carousel-banner%20(2).webp'} />
                    <source media={`(max-width: 768px)`} srcSet={'https://websiteoss.ecoflow.com/upload/image/1768186300142/home-carousel-banner%20(1).jpg'} />
                    <img
                        fetchpriority="high"
                        loading="eager"
                        src={'https://websiteoss.ecoflow.com/upload/image/1768186300302/home-carousel-banner.jpg'}
                        alt={t('A_title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>

            <div className="A-info">
                <div className="A-title">{t('A_title')}</div>
                <div className="A-desc">{t('A_desc')}</div>
                <EcoEmail
                    contactListId={[CONTACT_LIST_ID_MAP[locale as 'us']]}
                    fields={FIELDS_MAP[locale as 'us']}
                    defaultTermsCheck
                    tipsObj={{
                        placeholder: t('A_email_placeholder'),
                    }}
                    termsHtml={`* I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://us.ecoflow.com/pages/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Service</a>.`}
                />
            </div>
        </section>
    );
}

export default TheComp;
